<template>
  <div class="bg-[#0f172a] text-white border-b border-slate-800">
    <div class="max-w-7xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
      <!-- Trustpilot block (Left on desktop) -->
      <div class="flex items-center gap-2 sm:gap-3">
        <!-- Great text -->
        <span class="text-sm sm:text-base font-bold text-white">Great</span>
        
        <!-- Stars -->
        <div class="flex items-center gap-0.5">
          <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="#00b67a">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="#00b67a">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="#00b67a">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="#00b67a">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="#dcdce6">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        
        <!-- Reviews link -->
        <a
          href="https://www.trustpilot.com/review/gvgmall.com?utm_medium=trustbox&utm_source=MicroCombo"
          target="_blank"
          rel="noopener noreferrer"
          class="text-xs sm:text-sm text-white hover:text-green-400 transition underline decoration-white/30 hover:decoration-green-400/50"
        >
          1,066 reviews on
        </a>
        
        <!-- Trustpilot logo -->
        <span class="text-xs sm:text-sm font-semibold text-white/90">Trustpilot</span>
      </div>

      <!-- Coupon text (Right on desktop) -->
      <div class="flex items-center text-xs sm:text-sm text-white/90">
        Get 20% discount using the code <span class="font-bold tracking-wide text-white ml-1">GVG20</span>
      </div>
    </div>
  </div>
</template>
